import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { skillTrainingDeactive, getSkillDetails } from "../../actions/skill";
const DeactiveSkillTrainingDetails = ({
  auth: { isAuthenticated, user, users },
  trainingDeactiveData,
  onDeactiveModalChange,
  skillTrainingDeactive,
  getSkillDetails,
}) => {
  const [formData, setFormData] = useState({
    trainingDeactiveReason: "",
    isSubmitted: false,
  });

  const { trainingDeactiveReason } = formData;

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  //For setting mindate as todays date

  const onSubmit = (e) => {
    e.preventDefault();
    const finalData = {
      recordId: trainingDeactiveData ? trainingDeactiveData._id : "",
      trainingStatus: "Deactive",
      trainingDeactiveReason: trainingDeactiveReason,
      trainingDeactiveById: user && user._id,
      trainingDeactiveDateTime: new Date().toLocaleString("en-GB"),
      trainingDate: trainingDeactiveData.trainingDate,
      programId: trainingDeactiveData.programId,
      programName: trainingDeactiveData.programName,
    };
    skillTrainingDeactive(finalData);
    getSkillDetails(finalData);
    onDeactiveModalChange(true);
  };

  return !isAuthenticated || !user || !users ? (
    <Fragment></Fragment>
  ) : (
    <Fragment>
      <div className="col-lg-12 col-md-9 col-sm-9 col-12 ">
        <form className="row" onSubmit={(e) => onSubmit(e)}>
          <div className="row col-lg-12 col-md-9 col-sm-9 col-12 ">
            <div className="col-lg-12 col-md-4 col-sm-4 col-12">
              <label>Reason For Deactivation* :</label>
            </div>
            <div className="col-lg-12  col-md-4 col-sm-4 col-12">
              <textarea
                name="trainingDeactiveReason"
                id="trainingDeactiveReason"
                className="textarea form-control"
                rows="3"
                placeholder="Deactive Reason"
                onChange={(e) => onInputChange(e)}
                style={{ width: "100%" }}
                required
              ></textarea>
            </div>
            <div className="col-lg-12 col-md-4 col-sm-4 col-12 py-2">
              <label>Are You Sure You Want to Deactivate ??</label>
            </div>
            <div
              className="col-lg-12 col-md-9 col-sm-9 col-12 Savebutton"
              size="lg"
            >
              <input
                type="submit"
                name="Save"
                value="Submit"
                className="btn sub_form btn_continue Save float-right"
              />
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

DeactiveSkillTrainingDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  skill: PropTypes.object.isRequired,
  skillTrainingDeactive: PropTypes.func.isRequired,
  getSkillDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  skill: state.skill,
});

export default connect(mapStateToProps, {
  skillTrainingDeactive,
  getSkillDetails,
})(DeactiveSkillTrainingDetails);
